/** @flow */

import type { UserPermissionsState } from "./types";

const startRequest = (state: UserPermissionsState) => {
  ++state.requestsInProgress;
  return state;
};

const finishRequest = (state: UserPermissionsState) => {
  state.requestsInProgress = state.requestsInProgress <= 0 ? 0 : --state.requestsInProgress;
  return state;
};

const successRequest = (state: UserPermissionsState) => {
  state.error = null;
  return finishRequest(state);
};

const errorRequest = (state: UserPermissionsState) => ({ payload }: Object) => {
  state.success = false;
  state.error = payload;
  return finishRequest(state);
};

export const onGetEffectiveUserPermissions = (state: UserPermissionsState) => () =>
  startRequest(state);

export const onGetEffectiveUserPermissionsSuccess = (state: UserPermissionsState) => ({
  payload,
}: Object) => {
  state.effectiveUserPermissions = payload;
  return successRequest(state);
};

export const onGetEffectiveUserPermissionsError = errorRequest;

export const onGetEffectiveUserPermissionsSchema = (state: UserPermissionsState) => () =>
  startRequest(state);

export const onGetEffectiveUserPermissionsSchemaSuccess = (state: UserPermissionsState) => ({
  payload,
}: Object) => {
  state.schema = payload;
  return successRequest(state);
};

export const onGetEffectiveUserPermissionsSchemaError = errorRequest;

export const onUpdateEffectiveUserPermissions = (state: UserPermissionsState) => () =>
  startRequest(state);

export const onUpdateEffectiveUserPermissionsSuccess = (state: UserPermissionsState) => ({
  payload,
}: Object) => {
  state.effectiveUserPermissions = payload;
  return successRequest(state);
};

export const onUpdateEffectiveUserPermissionsError = errorRequest;

export const onToggleEmployeeUsersModal = (state: UserPermissionsState) => ({
  payload,
}: Object) => {
  state.modals.showEmployeeUsersModal = payload || !state.modals.showEmployeeUsersModal;
  return state;
};
